import AuthContext from '../../../../context/AuthContext.js';
import WithGASetup from '../../../WithGASetup';
import ClinicianRegistration from '././ClinicianRegistration.js';

export default WithGASetup(ClinicianRegistration, AuthContext);
